import { IGaEvent } from '../types/gtm';

export class Gtm {
  private static logEvent = (event: IGaEvent) => {
    if (window.gtmEnabled && window?.dataLayer) {
      window.dataLayer.push(event);
    }
  };

  static trackAppLinkClick = (appStore: 'apple' | 'google') => {
    const event: IGaEvent = {
      event: 'app_link_click',
      app_store: appStore,
    };
    this.logEvent(event);
  };

  static trackParcelTracked = (tn: string) => {
    const event: IGaEvent = {
      event: 'parcel_tracked',
      tracking_number: tn,
    };
    this.logEvent(event);
  };

  static trackParcelTrackedSuccess = (tn: string) => {
    const event: IGaEvent = {
      event: 'parcel_tracked_success',
      tracking_number: tn,
    };
    this.logEvent(event);
  };

  static trackParcelTrackedError = (tn: string) => {
    const event: IGaEvent = {
      event: 'parcel_tracked_error',
      tracking_number: tn,
    };
    this.logEvent(event);
  };
}
